import * as Constants from '../../constants';

import { useEffect, useState } from 'react';

import { Button } from "react-bootstrap";

import { faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ApplicationFormModal from '../../components/admin/applications/ApplicationFormModal.jsx';
import ApplicationsDashboardCards from '../../components/admin/applications/ApplicationsDashboardCards.jsx';
import ApplicationsTable from '../../components/admin/applications/ApplicationsTable.jsx';
import ConfirmationModal from '../../components/widget/ConfirmationModal.jsx';
import Loading from '../../components/widget/Loading.js';

function ApplicationsPage() {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [applications, setApplications] = useState([]);
    const [applicationTypes, setApplicationTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [selectedApplication, setSelectedApplication] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleEdit = (application) => {
        setSelectedApplication(application);
        setShowModal(true);
    }

    const handleDelete = (application) => {
        setSelectedApplication(application)
        setShowDeleteModal(true)
    }

    const handleDeleteConfirmation = (id) => {
        setShowDeleteModal(false)
        setIsLoading(true);

        const controller = new AbortController();
        const signal = controller.signal;
        const token = localStorage.getItem("token");

        fetch(Constants.APPLICATIONS_DELETE, {
            method: 'DELETE',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id }),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setApplications(prevApplications => prevApplications.filter(application => application.id !== id));
                } else {
                    console.error('Erro na API:', responseJson.message);
                }
                setSelectedApplication(null);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') return;

                console.error('Erro na requisição de remoção:', error.message || error);
                setIsLoading(false);
            });
    }

    const handleCreate = () => {
        setSelectedApplication(null);
        setShowModal(true)
    }

    const handleSave = (application) => {
        setIsLoading(true);

        let url = Constants.APPLICATIONS_CREATE
        let method = 'POST'
        if (application.id) {
            url = Constants.APPLICATIONS_UPDATE
            method = 'PUT'
        }
        const controller = new AbortController();
        const signal = controller.signal;

        const token = localStorage.getItem("token");

        fetch(url, {
            method: method,
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(application),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    const savedApplication = responseJson.data; // O usuário que veio do banco
                    if (application.id) {
                        // Se for EDIÇÃO: substitui o usuário antigo pelo novo no array
                        setApplications(prev => prev.map(u => u.id === savedApplication.id ? savedApplication : u));
                    } else {
                        // Se for CRIAÇÃO: adiciona o novo usuário ao final (ou início) da lista
                        setApplications(prev => [...prev, savedApplication]);
                    }

                    // Se preferir recarregar tudo do zero, chame sua função de fetch inicial:
                    // fetchAllApplications(); 
                }
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                console.error('Erro na requisição:', error.message || error);
                setIsLoading(false);
            });
    };

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {

            try {

                setIsLoading(true);

                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                const [applicationsRes] = await Promise.all([
                    fetch(Constants.APPLICATIONS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!applicationsRes.ok) {
                    const err = await applicationsRes.json();
                    throw err;
                }

                const applicationsJson = await applicationsRes.json();

                if (applicationsJson.status === "success") {
                    setApplications(applicationsJson.data);
                }
            } catch (error) {

                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <div className="d-flex justify-content-between mb-4">

                        <h3 style={{ color: '#fff' }}>Gerenciamento de Aplicações</h3>

                        <Button onClick={handleCreate}>
                            <FontAwesomeIcon icon={faPlus} /> Nova Aplicação
                        </Button>

                    </div>
                    <ApplicationsDashboardCards applications={applications}/>
                    <ApplicationsTable
                        applications={applications}
                        applicationTypes={applicationTypes}
                        statusTypes={statusTypes}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                    <ApplicationFormModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} application={selectedApplication} />
                </>
            }
            {isLoading && <>
                <Loading />
            </>}

            {showDeleteModal && <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Licença"
                message={<p>Tem certeza que deseja excluir a aplicação <strong>{selectedApplication?.title}</strong><strong>{selectedApplication?.device}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                id={selectedApplication.id}
            />
            }
        </div>
    </>
}

export default ApplicationsPage;